module.exports = __webpack_public_path__ + "static/media/then_now_delimiter.69d82c00.svg";